export default __webpack_public_path__ + "static/media/Dolphins.70e652f1.png";